import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase, ref, child } from "firebase/database";
import {
  collection,
  doc,
  updateDoc,
  setDoc,
  getDoc,
  query,
  where,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAWUO3zOAPhhhfOeP3Hnxsl3wDRGLpgF50",
  authDomain: "shop-split.firebaseapp.com",
  databaseURL: "https://shop-split-default-rtdb.firebaseio.com",
  projectId: "shop-split",
  storageBucket: "shop-split.appspot.com",
  messagingSenderId: "293532759661",
  appId: "1:293532759661:web:b28d48250d75a8804af164",
  measurementId: "G-HD5JTZ8YWY"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const db = getDatabase(app)

export { auth, db };